import React, { useState } from "react";
import { ShoppingBasket } from "lucide-react";
import { useSnackbar } from 'notistack';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProduct, setProduct } from "./state";
import { useSelector } from "react-redux";

function Item({ id, prix, title, image }) {
      const langue = useSelector((state) => state.langue.value);
  
  const [selectedWeight, setSelectedWeight] = useState(1); // Poids par défaut à 250g
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const products = useSelector((state) => state.panier.value);

  const AjoutPanier = () => {
    
  
    const prixTotal = (prix * selectedWeight) ;
  
    // Vérifier si le produit avec le même ID existe déjà dans le panier
    const existingProduct = products.find(item => item.id === id);
  
    if (existingProduct) {
      // Mise à jour du produit existant
      const updatedProduct = { 
        ...existingProduct,
        weight: existingProduct.weight + selectedWeight, 
        price: existingProduct.price + prixTotal, 
        quantity: existingProduct.quantity + 1 
      };
  
      // Mettre à jour le panier en remplaçant l'ancien produit
      const updatedCart = products.map(item => 
        item.id === id ? updatedProduct : item
      );
  
      dispatch(setProduct(updatedCart)); // Mise à jour du panier avec Redux
    } else {
      // Ajouter un nouveau produit au panier
      dispatch(addProduct({ 
        id, 
        name: title, 
        price: prixTotal, 
        weight: selectedWeight, 
        image,
        quantity: 1 
      }));
    }
  
    enqueueSnackbar(`${selectedWeight}g de ${title} ajouté au Panier`, { variant: "success" });
  };
  

  return (
    <div className="h-auto w-44 m-2 sm:m-4 rounded-xl max-[420px]:w-40 border shadow-md">
      {/* Image */}
      <img 
        onClick={() => navigate(`/page/${id}`)} 
        className="h-44 w-full object-cover rounded-lg cursor-pointer" 
        src={image} 
        alt={title} 
      />

      {/* Nom et prix */}
      <div className="p-1">
        <p className="mx-1 font-bold">{title}</p>
        <p className="text-gray-500 text-xs mx-1">{prix} DA</p>

        {/* Sélecteur de poids */}
        <div className="flex flex-row items-center justify-between mt-2">
          <select
            className="border border-gray-400 rounded-md font-bold w-16 text-gray-700 focus:ring-black"
            value={selectedWeight}
            onChange={(e) => setSelectedWeight(Number(e.target.value))}
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="5">5</option>
            <option value="10">10</option>
            
          </select>

          {/* Prix affiché */}
          <p className="text-green-600 font-bold mx-1">
            {`${(prix * selectedWeight) } DA`}
          </p>
        </div>

        {/* Bouton Ajouter au panier */}
        <button 
          onClick={AjoutPanier}
          className="h-auto bg-black p-1 mt-2 text-xs w-full rounded-xl text-white text-center 
            flex flex-row items-center justify-center font-bold hover:bg-gray-800 
            transition duration-200"
        >
          Ajouter au panier
          <ShoppingBasket className="ml-2 size-5" />
        </button>
      </div>
    </div>
  );
}

export default Item;
